import React from 'react';
import { Modal, Button } from 'antd';

export default function TaskDeleteModal({ open, onCancel, onConfirm, task, loading }) {
  return (
    <Modal
      title="Delete task"
      open={!!open}
      onCancel={onCancel}
      footer={[
        <Button
          key="delete"
          danger
          onClick={onConfirm}
          loading={loading}
          className="app-btn-delete"
        >
          Delete
        </Button>,
        <Button key="cancel" onClick={onCancel} className="app-btn-cancel">
          Cancel
        </Button>,
      ]}
      destroyOnClose
    >
      {task && (
        <>
          Are you sure you want to delete <strong>{task.title}</strong>? This action
          cannot be undone.
        </>
      )}
    </Modal>
  );
}
